<div class="container-password">
  <div>
    <h4 class="small-margin k-text-center renew-pass-title">
      <b>{{
        (updatePassword ? 'Mot de passe oublié' : error ? 'Impossible de valider' : 'Email envoyé !') | uppercase
      }}</b>
    </h4>
    <form *ngIf="updatePassword" [formGroup]="renewForm" class="align-center" (ngSubmit)="renew()">
      <div class="small-margin">
        <input
          kendoTextBox
          class="full-size reset-password"
          formControlName="login"
          [placeholder]="'Veuillez saisir votre adresse e-mail'"
          [ngClass]="{ 'alert-border': invalidLogin }"
        />
      </div>
      <br />
      <div *ngIf="invalidLogin" class="primary-color">
        Veuillez saisir une adresse e-mail.
      </div>
      <div class="renew-button primary-color">
        <button class="colored-text full-size primary-background" kendoButton [disabled]="submitted">
          <ng-container *ngIf="!submitted; else loading">
            VALIDER
          </ng-container>
          <ng-template #loading>
            CHARGEMENT...
          </ng-template>
        </button>
      </div>
    </form>
    <div *ngIf="!updatePassword" class="align-center msg-content">
      <p class="texte">
        <ng-container *ngIf="!error; else errorContainer">
          Un email contenant votre nouveau mot de passe vient de vous être envoyé.
        </ng-container>
        <ng-template #errorContainer>
          Veuillez renseigner une adresse mail valide.
        </ng-template>
      </p>
      <button
        class="k-button ok-class colored-text primary-background primary-color"
        kendoButton
        type="button"
        (click)="closePopup()"
      >
        OK
      </button>
    </div>
  </div>
</div>
